import ZkDepartment from './src/main.vue'
ZkDepartment.install = function (Vue) {
  Vue.component(ZkDepartment.name, ZkDepartment)
}

export default ZkDepartment



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/department/index.js